module.exports = __webpack_public_path__ + "img/Dave.81b3e999.png";